export function getRoleCodes(user) {
  return user?.roles ?? [];
}

export function hasRole(user, roleCode) {
  return getRoleCodes(user).includes(roleCode);
}

export function hasAnyRole(user, roleCodes = []) {
  if (!roleCodes.length) return true;
  return roleCodes.some((roleCode) => hasRole(user, roleCode));
}

export function isProjectManager(user) {
  return hasRole(user, "PM") || Boolean(user?.isAdmin);
}

export function canAccessNavigationItem(user, item) {
  if (!item.roles?.length) return true;
  if (isProjectManager(user)) return true;
  return hasAnyRole(user, item.roles);
}
